import { cn } from "@/lib/utils";

export interface TabsProps<T extends string> {
  items: readonly { value: T; label: string; count?: number }[];
  value: T;
  onValueChange: (value: T) => void;
  className?: string;
}

/** Lightweight segmented control used for in-page filtering (status, kind, …). */
export const Tabs = <T extends string>({ items, value, onValueChange, className }: TabsProps<T>) => (
  <div
    role="tablist"
    className={cn("inline-flex flex-wrap items-center gap-1 rounded-lg bg-muted p-1", className)}
  >
    {items.map((item) => (
      <button
        key={item.value}
        role="tab"
        type="button"
        aria-selected={item.value === value}
        onClick={() => onValueChange(item.value)}
        className={cn(
          "rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
          item.value === value
            ? "bg-card text-foreground shadow-sm"
            : "text-muted-foreground hover:text-foreground",
        )}
      >
        {item.label}
        {item.count === undefined ? null : (
          <span className="ml-1.5 text-xs text-muted-foreground">{item.count}</span>
        )}
      </button>
    ))}
  </div>
);
